import React from 'react'
import { BasicSelector, MwInputText, MwTextArea } from '../../components/ui'
import {  useTranslation } from 'react-i18next';


const SettingListItem = ({
    settingName,
    settingValue,
    filterDefineSetting,
    setGeneralSetting,
    generalSetting,
    currentLangId,
    prefixLang = 'general',
    readOnly = false
}) => {
    const [t] = useTranslation('settings')

    const getValue = (settingName,value) => {
        return filterDefineSetting(settingName)?.valueTypeList?.filter(item => (item.value === value && item.lang === currentLangId ))[0]?.label
    }

    const handleList = (settingName) => {
        const _genList = filterDefineSetting(settingName)?.valueTypeList.filter(item => item.lang === currentLangId);
        const _list = _genList.map(item => ({
            label: item.label,
            value: {[settingName]: item.value}
        }));
        return _list;
    }
    const onSelected = (item) => {
        const obj = item.value;
        setGeneralSetting({...generalSetting, ...obj })
        console.log(generalSetting)
    }
    const displayValue = filterDefineSetting(settingName)?.valueType === 'list'
        ? (getValue(settingName, settingValue) || settingValue)
        : settingValue

    return (
        <div className='bg-white p-4 rounded-lg shadow-sm border border-gray-200'>
            <div className='text-slate-500 font-semibold mb-2'>{t(`${prefixLang}.${settingName}`)}</div>
            {readOnly ? (
                <MwInputText value={displayValue} disabled={true} classNameInput="text-start w-full" />
            ) : settingValue === 'true' || settingValue === 'false' ? (
                <BasicSelector
                    className="w-full"
                    label={t(`${prefixLang}.${settingValue.toUpperCase()}`)}
                    listItem={[
                        { label: t(`${prefixLang}.TRUE`), value: { [settingName]: 'true' } },
                        { label: t(`${prefixLang}.FALSE`), value: { [settingName]: 'false' } }
                    ]}
                    onSelected={onSelected}
                />
            ) : filterDefineSetting(settingName)?.valueType === 'list' ? (
                <BasicSelector
                    className="w-full"
                    label={getValue(settingName, settingValue)}
                    listItem={handleList(settingName)}
                    onSelected={onSelected}
                />
            ) : filterDefineSetting(settingName)?.valueType === 'textArea' ? (
                <MwTextArea
                    value={settingValue}
                    rows={4}
                    onChange={(e)=>setGeneralSetting({...generalSetting, [settingName]:e.target.value})}
                    className="w-full"
                />
            ) : (
                <MwInputText
                    value={settingValue}
                    classNameInput="text-start w-full"
                    onChange={(e)=>setGeneralSetting({...generalSetting, [settingName]:e.target.value})}
                />
            )}
        </div>
    )
}

export default SettingListItem
